// extracted by mini-css-extract-plugin
export default {"toggle":"_3uUg6pUgrQRd35TuBtuCv2","tooltipText":"_1uEC8ORC1L6CYYamIlPre_"};